export default "__VITE_ASSET__sGfEwXcs__"